// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'

import router from './router'
import store from './store'
import englishlanguage from './languages/en.json'
import russianlanguage from './languages/ru.json'
import VeeValidate from 'vee-validate'

Vue.config.productionTip = false
Vue.use(VeeValidate)
Vue.use(VueI18n)

export default{
  data () {
    return {
      englishlanguage, russianlanguage
    }
  }
}

const messages = {
  en: {
    message: englishlanguage
  },
  ru: {
    message: russianlanguage
  }
}

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js